import * as Types from './types';
import { Dispatch } from 'redux';
import {
  IAction,
  IActionMethods,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as NotificationService from '../../../services/api/notification';
import ModalActions from '../gl_modal_reducer/actions';
import { ModalIDs } from '../gl_modal_reducer/types';

/** Fetch FetchNotificationListInput  */

interface FetchNotificationListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  vatNumber?: string | null;
  notificationType?: string | null;
  notificationDateFrom?: string | null;
  notificationDateTo?: string | null;
}

class FetchNotificationList implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_NOTIFICATION_LIST,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_NOTIFICATION_LIST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_NOTIFICATION_LIST,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: FetchNotificationListInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await NotificationService.fetchNotificationList(payload);
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetcNotificationList Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      }
    };
  }
}

/** Add NewNotification  */

interface AddNewNotificationInput {
  notification_id: number | null;
  applicant_id: number | null;
  notification_type: string;
  notification_title: string;
  notification_message: string;
  is_read: number | null;
  created_by: string;
  created_at: string;
  modified_by: string;
  modified_at: string;
  fetchNotificationInput: FetchNotificationListInput;
}

class AddNewNotification implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_ADD_NOTIFICATION,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_ADD_NOTIFICATION,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_ADD_NOTIFICATION,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: AddNewNotificationInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        const { fetchNotificationInput, ...rest } = payload;

        dispatch(this.onPending());
        let response = await NotificationService.addNotification(rest);
        dispatch(this.onSuccess(response.data));
        dispatch(new FetchNotificationList().action(fetchNotificationInput));

        dispatch(
          ModalActions.closeModalAction({
            modalID: ModalIDs.MODAL_ADD_EDIT_NOTIFICATION,
          })
        );
      } catch (error: any) {
        // console.log('AddNewNotification Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      } finally {
        // add something
      }
    };
  }
}

/** Edt Notification  */

interface EditNotificationInput {
  notification_id: number | null;
  applicant_id: number | null;
  notification_type: string;
  notification_title: string;
  notification_message: string;
  is_read: number | null;
  created_by: string;
  created_at: string;
  modified_by: string;
  modified_at: string;
  fetchNotificationInput: FetchNotificationListInput;
}

class EditNotification implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_EDIT_NOTIFICATION,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_EDIT_NOTIFICATION,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_EDIT_NOTIFICATION,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: EditNotificationInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        const { fetchNotificationInput, ...rest } = payload;

        dispatch(this.onPending());
        let response = await NotificationService.editNotification(payload);
        dispatch(this.onSuccess(response.data));
        dispatch(new FetchNotificationList().action(fetchNotificationInput));

        dispatch(
          ModalActions.closeModalAction({
            modalID: ModalIDs.MODAL_ADD_EDIT_NOTIFICATION,
          })
        );
      } catch (error: any) {
        // console.log('EditNotification Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      } finally {
        // add something
      }
    };
  }
}

class FetchReminderList implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_REMINDER_LIST,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_REMINDER_LIST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_REMINDER_LIST,
      status: StateStatus.Failed,
      data: KEEP_THE_SAME,
    };
  }

  action(payload: NotificationService.FetchReminderListInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await NotificationService.fetchReminderList(payload);
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetcReminderList Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      }
    };
  }
}

interface IViewNotificationAction {
  notificationId: number;
  onSuccess: () => void;
}
class SetNotificationView implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_NOTIFICATION_VIEW,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(): IAction {
    return {
      type: Types.SET_NOTIFICATION_VIEW,
      status: StateStatus.Success,
      data: {},
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_NOTIFICATION_VIEW,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action({ notificationId, onSuccess }: IViewNotificationAction): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        await NotificationService.setNotificationView(notificationId);
        dispatch(this.onSuccess());
        onSuccess && onSuccess();
      } catch (error: any) {
        // console.log('Notification View Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchUnreadNotificationCount implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_UNREAD_NOTIFICATION_COUNT,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_UNREAD_NOTIFICATION_COUNT,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_UNREAD_NOTIFICATION_COUNT,
      status: StateStatus.Failed,
      data: 0,
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await NotificationService.fetchUnreadNotificationCount();
        dispatch(this.onSuccess(response.data.total));
      } catch (error: any) {
        // console.log('FetchUnreadNotificationCount Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class ClearUnreadNotificationCount implements IActionMethods {
  onFailed(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onPending(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onSuccess(): IAction {
    return {
      type: Types.SET_UNREAD_NOTIFICATION_COUNT,
      status: StateStatus.Success,
      data: 0,
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      dispatch(this.onSuccess());
    };
  }
}

export default {
  fetchNotificationListAction: (payload: FetchNotificationListInput) =>
    new FetchNotificationList().action(payload),
  addNewNotificationAction: (payload: AddNewNotificationInput) =>
    new AddNewNotification().action(payload),
  editNotificationAction: (payload: EditNotificationInput) =>
    new EditNotification().action(payload),
  fetchReminderListAction: (
    payload: NotificationService.FetchReminderListInput
  ) => new FetchReminderList().action(payload),
  setNotificationViewAction: (payload: IViewNotificationAction) =>
    new SetNotificationView().action(payload),
  fetchUnreadNotificationCountAction: () =>
    new FetchUnreadNotificationCount().action(),
  clearUnreadNotificationCountAction: () =>
    new ClearUnreadNotificationCount().action(),
};
